module.exports = __webpack_public_path__ + "cad3fca45356c19b7069366b34a50d16.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-alligator.png
// module id = 1272
// module chunks = 0